<template>
  <v-app black>

    <v-navigation-drawer app v-model="drawer" align="center" justify="center" color="black" :width="!$vuetify.breakpoint.xsOnly?'50%':'80%'" fixed temporary>
      <v-card color="transparent" flat class="pa-10 text-center">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click.stop="drawer = !drawer"><v-icon x-large>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider class="mx-5"></v-divider>
        <a href="/#hom">Начало</a>
        <v-divider class="mx-5"></v-divider>
        <a href="/#faq">ЧаВо</a>
        <v-divider class="mx-5"></v-divider>
        <a href="/#sts">Цифры</a>
        <v-divider class="mx-5"></v-divider>
        <a href="/#dem">Демо</a>
        <v-divider class="mx-5"></v-divider>
        <a href="/#prc">Цены</a>
        <template v-if="this.$route.path=='/'">
          <v-divider class="mx-5"></v-divider>
          <v-btn x-large outlined :to="this.paypost.successURL">Скачать</v-btn>
        </template>
        
      </v-card>
    </v-navigation-drawer>

    <v-app-bar fixed extended flat dark class="mt-4 pa-4" color="transparent" :collapse="$vuetify.breakpoint.xsOnly">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <template v-if="$vuetify.breakpoint.xsOnly">
          <v-spacer></v-spacer>
          <v-toolbar-title>
          <strong>MOS</strong>BASE
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </template>
        <template v-else>
          <v-toolbar-title>
          <strong>MOS</strong>BAS
          <v-divider class="mx-3" vertical></v-divider>
          <a href="/#hom">Начало</a>
          <v-divider class="mx-3" vertical></v-divider>
          <a href="/#faq">ЧаВо</a>
          <v-divider class="mx-3" vertical></v-divider>
          <a href="/#sts">Цифры</a>
          <v-divider class="mx-3" vertical></v-divider>
          <a href="/#dem">Демо</a>
          <v-divider class="mx-3" vertical></v-divider>
          <a href="/#prc">Цены</a>
          <template v-if="this.$route.path=='/'">
            <v-divider class="mx-3" vertical></v-divider>
            <v-btn outlined :to="this.paypost.successURL">Скачать</v-btn>
          </template>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div>
            <v-input
              v-if="!$vuetify.breakpoint.xsOnly"
              class="mr-5"
              width="50px"
              grow
              messages="Актуальность базы"
              prepend-icon="mdi-alert-circle-outline"
            >
              Ноябрь 2019
            </v-input>
          </div>
        </template>

        <v-badge overlap left color="red accent-4">
          <template v-slot:badge>
            <v-icon dark>
              mdi-bell
            </v-icon>
          </template>
          <v-btn  href="javascript:jivo_api.open();" icon outlined>
            <v-icon>mdi-forum-outline</v-icon>
          </v-btn>
        </v-badge>

    </v-app-bar>

    <v-content >
      <router-view/>
    </v-content>

    <v-footer dark fixed padless class="pa-8" color="transparent">

      <v-row no-gutters class="text-center">
        <v-col cols="12" md="3">
          <template v-if="!$vuetify.breakpoint.xsOnly">
            <strong>MOS</strong>BAS &copy; 2019
          </template>
        </v-col>
        <v-col cols="12" md="6">

          <v-dialog v-if="this.$route.path=='/'" light v-model="payer" hide-overlay max-width="600" transition="dialog-bottom-transition">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" :disabled="payer" dark outlined>Купить онлайн</v-btn>
            </template>
            <v-card class="paypage pa-8">
              <v-toolbar flat  color="transparent">
                <v-toolbar-title>Форма оплаты</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="payer = false">
                  <v-icon large>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <form method="POST" id="payForm" action="https://money.yandex.ru/quickpay/confirm.xml">
                <input type="hidden" name="quickpay-form" value="shop">
                <input type="hidden" name="receiver"    :value="paypost.receiver">
                <input type="hidden" name="formcomment" :value="paypost.formcomment">
                <input type="hidden" name="short-dest"  :value="paypost.shortdest">
                <input type="hidden" name="label"       :value="paypost.label">
                <input type="hidden" name="targets"     :value="paypost.targets">
                <input type="hidden" name="sum"         :value="paypost.sum" data-type="number">
                <input type="hidden" name="paymentType" :value="paypost.paymentType">
                <input type="hidden" name="successURL"  :value="'https://mosbas.web.app'+paypost.successURL">
                <input type="hidden" name="comment"     :value="paypost.comment">
                <input type="hidden" name="need-fio"     value="false">
                <input type="hidden" name="need-email"   value="true">
                <input type="hidden" name="need-phone"   value="false">
                <input type="hidden" name="need-address" value="false">

                <v-input messages="Назначение платежа">
                  {{paypost.targets}}
                </v-input>
                <!--
                <v-divider class="my-3"></v-divider>
                <v-input messages="Получатель">
                  {{paypost.receiver}}
                </v-input>
                -->
                <v-divider class="my-3"></v-divider>
                <v-input messages="Номер платежа (ПОНАДОБИТСЯ ДЛЯ ПОЛУЧЕНИЯ ТОВАРА)">
                  {{paypost.label}}
                </v-input>
                <v-divider class="my-3"></v-divider>
                <v-input messages="Сумма">
                  {{paypost.sum}} руб.
                </v-input>
                <v-divider class="my-3"></v-divider>

                <div class="text-center">
                  <h4>Выберите способ оплаты</h4>
                  <v-btn-toggle v-model="paypost.paymentType" class="pb-6 pt-2">
                    <v-btn value="PC" small>{{$vuetify.breakpoint.xsOnly?'Я.Деньги':'Яндекс.Деньгами'}}</v-btn>
                    <v-btn value="AC" small>{{$vuetify.breakpoint.xsOnly?'Банк.карта':'Банковской картой'}}</v-btn>
                  </v-btn-toggle>
                </div>

                <v-row no-gutters>
                  <v-col cols="12" sm="6" class="pa-1">
                    <v-btn block type="submit" :disabled="paypost.paymentType==null||paypost.label==null||paypost.targets==null" color="orange accent-3">Перейти к оплате<v-icon small right>mdi-arrow-right</v-icon></v-btn>
                  </v-col> 
                  <v-col cols="12" sm="6" class="pa-1">
                    <v-btn block color="grey" text href="javascript:jivo_api.open();" outlined>
                      <v-icon left>mdi-forum-outline</v-icon>
                      <span>Спросить в Чате</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-text-field
                  v-model="comment"
                  class="px-1"
                  hint="Комментарий"
                  placeholder="Комментарий"
                  dense
                  outlined
                ></v-text-field>
                <p>После оплаты вы будете перенаправлены на страницу для получения MOSBAS`ы, а на указанный email выслано информационное письмо</p>
              </form>
              
            </v-card>
          </v-dialog>

          <br><small>Безопасно с Яндекс Деньги</small>
        </v-col>
        <v-col cols="12" md="3">
          <template v-if="!$vuetify.breakpoint.xsOnly">
            <v-btn style="border-bottom:0px;" text href="mailto:mos2base@yandex.ru" target="_blank"><v-icon class="mr-2">mdi-email-send-outline</v-icon>Написать</v-btn>
          </template>
        </v-col>
      </v-row>

    <v-bottom-sheet v-model="snackbar">
      <v-sheet dark style="background: rgba(0,0,0,0.9);" class="text-center" height="200px">
        <v-btn class="mt-6" outlined @click="snackbar = !snackbar">Да, Согласен</v-btn>
        <div class="mt-6">Этот сайт использует куки-файлы и другие технологии, 
          чтобы сделать работу сайта максимально комфортной и удобной для вас.<br>
          Вы согласны на использование файлов cookie?</div>
      </v-sheet>
    </v-bottom-sheet>

    </v-footer>

  </v-app>
</template>

<script>
function checkINN(inputNumber){
    inputNumber = "" + inputNumber;
    inputNumber = inputNumber.split('');
    if((inputNumber.length == 12) && ((inputNumber[10] == ((7 * inputNumber[ 0] + 2 * inputNumber[1] + 4 * inputNumber[2] + 10 * inputNumber[3] + 3 * inputNumber[4] + 5 * inputNumber[5] + 9 * inputNumber[6] + 4 * inputNumber[7] + 6 * inputNumber[8] + 8 * inputNumber[9]) % 11) % 10) && (inputNumber[11] == ((3 * inputNumber[ 0] + 7 * inputNumber[1] + 2 * inputNumber[2] + 4 * inputNumber[3] + 10 * inputNumber[4] + 3 * inputNumber[5] + 5 * inputNumber[6] + 9 * inputNumber[7] + 4 * inputNumber[8] + 6 * inputNumber[9] + 8 * inputNumber[10]) % 11) % 10))){
        return true;
    }
    return false;
}
export default {
  name: 'App',
  data(){
    return {
      snackbar:true,
      drawer: false,
      payer:false,
      comment:null,
      paypost:{
        receiver:"41001156499023",
        formcomment:"MosBas / База Данных",
        shortdest:"MosBas / База Данных",
        label:null,
        targets:null,
        sum: Number(2020),
        comment:"",
        paymentType:null,
        successURL:null
      }
    }
  },
  watch: {
    comment: function (val) {
      if( this.comment != null){
        if( checkINN(val) ){
          this.paypost.sum=Number(1500)
        } else {
          this.paypost.sum=Number(2020)
        }
        this.paypost.formcomment = val
      } else {
        this.paypost.formcomment = 'MosBas / База Данных'
      }
    }
  },
  created(){
    this.orderId()

    var jivoSite = document.createElement('script');    
    jivoSite.setAttribute('type',"text/javascript");
    jivoSite.setAttribute('async',true);
    jivoSite.setAttribute('src',"//code.jivosite.com/widget.js");
    jivoSite.setAttribute('data-jv-id',"tZT6xjwZEE");
    document.head.appendChild(jivoSite);

    var metagoogle = document.createElement('meta');    
    metagoogle.setAttribute('name',"google-site-verification");
    metagoogle.setAttribute('content','MlBskMSufo4QuzHvbYUrHGhVUQhBiF7DCITRISVdQ-Y');
    document.head.appendChild(metagoogle);

  },
  methods:{
    orderId(){
      let min = 1000000
      let max = 9999999
      let rand = min + Math.random() * (max + 1 - min)
      let payment = Math.floor(rand)
      this.paypost.label = payment
      this.paypost.targets = "База MosBas ["+payment+"]"
      this.paypost.successURL = "/status/"+payment
    },
    openAbout(){
      this.$root.$emit('openAbout')
    },
    openDemo(){
      this.$root.$emit('openDemo')
    }
  },
  showChat(){
    document.jivo_api.open();
  }
};
</script>
<style>
  @import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');
  h2 { font-size: 2.5em; font-weight: 600; line-height: 1.1em; }
  h3 { font-size: 2.0em; font-weight: 100; line-height: 1.1em; }
  .v-application {
    font-family: 'Roboto', sans-serif !important;
  }
  .v-navigation-drawer {
    font-size: 3em;
    opacity:.8!important;
  }
  a { color: #ffffff!important; font-weight: 100; text-decoration: unset; border-bottom: 1px dashed #ffffff; }
  .theme--dark.v-chip:not(.v-chip--active) {
    background: rgba(0,0,0,0.5)!important;
}
.paypage {
    background-color: #fff!important;
    opacity:.95!important;
}
</style>
